import React from "react";
import ReactDOM from "react-dom";
// redux
import { Provider } from "react-redux";
import { store } from "./app/store";
// fonts
import "./fonts/din/DIN-Bold.ttf";
import { createRoot } from "react-dom/client";
// css
import "./index.css";
// material ui
import { ThemeProvider } from "@mui/material";
import { theme } from "./theme/Theme";
// components
import App from "./App";

//routes
import { IS_LOGGED_IN } from "./utils/routes";
import axios from "axios"


// ------------------------------------------------------------

const root = createRoot(document.getElementById("root"));


axios.interceptors.response.use(function(response) {
  return response;
}, function(error) {
  if (error.response.status === 401 || error.response.status === 403) {
    // const checkStatusUrl = 'https://dev.piedap.com/piedapiam/v1/api/authentication/is-piedap-user-logged-in';

    axios.get(IS_LOGGED_IN , {withCredentials:true}).then(response => {

      console.log("response " , response)
      if (response.data === false) {
        window.location.href = '/';
      }
    }).catch(error => {
      console.error('Error checking user login status:', error);
    });
  }
  return Promise.reject(error);
});

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </Provider>,
 
);
